import React, { useState } from 'react';
import styled from 'styled-components';
import type { Dayjs } from 'dayjs';
import {
  StyledModal,
  ModalFooter,
  CancelButton,
  PrimaryButton,
  FormContainer,
} from 'components/Shared/StyledModal';
import { DatePicker } from 'components/Base/DatePicker';

export type CompletedDateModalProps = {
  open: boolean;
  onCancel: () => void;
  onAdd: (date: Dayjs) => void;
  initialDate?: Dayjs | null;
  confirmLoading?: boolean;
};

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #1b1a1c;

  .required {
    color: #ff4d4f;
    margin-left: 4px;
  }
`;

const CompletedDateModal: React.FC<CompletedDateModalProps> = ({
  open,
  onCancel,
  onAdd,
  initialDate = null,
  confirmLoading = false,
}) => {
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(initialDate);

  const handleAdd = () => {
    if (!selectedDate) return;
    onAdd(selectedDate);
  };

  return (
    <StyledModal
      open={open}
      title="Add completed date"
      onCancel={onCancel}
      footer={null}
      centered
      closeIcon={<span>×</span>}
      width={400}
      getContainer={() => document.body}
    >
      <FormContainer>
        <Field>
          <Label>
            Completed Date<span className="required">*</span>
          </Label>
          <DatePicker
            value={selectedDate}
            onChange={setSelectedDate}
            placeholder="Select Date"
            format="MMM DD, YYYY"
            style={{ width: '100%' }}
          />
        </Field>

        <ModalFooter>
          <CancelButton
            onClick={onCancel}
            color="primary"
            disabled={confirmLoading}
          >
            Cancel
          </CancelButton>
          <PrimaryButton
            type="primary"
            onClick={handleAdd}
            color="primary"
            loading={confirmLoading}
            disabled={!selectedDate}
          >
            Add
          </PrimaryButton>
        </ModalFooter>
      </FormContainer>
    </StyledModal>
  );
};

export default CompletedDateModal;
